var map = {
  "./da.json": [
    "34708",
    [
      20629
    ]
  ],
  "./fi.json": [
    "94278",
    [
      34955
    ]
  ],
  "./sv.json": [
    "21270",
    [
      72443
    ]
  ],
  "./ja.json": [
    "86386",
    [
      33135
    ]
  ],
  "./lt.json": [
    "60499",
    [
      44400
    ]
  ],
  "./sl.json": [
    "25263",
    [
      65997
    ]
  ],
  "./fr.json": [
    "24927",
    [
      3892
    ]
  ],
  "./es.json": [
    "55971",
    [
      35680
    ]
  ],
  "./no.json": [
    "92528",
    [
      45609
    ]
  ],
  "./cs.json": [
    "25698",
    [
      50422
    ]
  ],
  "./en.json": [
    "97060",
    [
      52933
    ]
  ],
  "./description/en.json": [
    "30035",
    [
      65040
    ]
  ],
  "./pl.json": [
    "15463",
    [
      15340
    ]
  ],
  "./hu.json": [
    "88004",
    [
      94373
    ]
  ],
  "./nl.json": [
    "74221",
    [
      30366
    ]
  ],
  "./de.json": [
    "44024",
    [
      84929
    ]
  ],
  "./pt.json": [
    "5855",
    [
      18612
    ]
  ],
  "./it.json": [
    "23338",
    [
      25111
    ]
  ],
  "./et.json": [
    "82158",
    [
      93923
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 2558;
module.exports = __rspack_async_context;
